<template>
    <div>
        <editor-js
            :data="data.columns[0].content"
            @save="(d) => save(0, d)"
        />
    </div>
</template>

<script>
    import EditorJs from "../EditorJs.vue";

    export default {
        components: {EditorJs},
        props: ['data'],
        methods: {
            save(column, data) {
                this.data.columns[column].content = data;
            }
        },
        created() {
            if (!this.data.columns) {
                this.data.columns = [
                    {column: 1, content: null, attributes: {}}
                ];
            }
        }
    };
</script>

<style scoped lang="scss">

</style>
